import { createContext, useContext, useState, type ReactNode } from 'react'
import { AvisoLegalContent } from './legal-contents/AvisoLegalContent'
import { PoliticaCookiesContent } from './legal-contents/PoliticaCookiesContent'
import { PoliticaPrivacidadContent } from './legal-contents/PoliticaPrivacidadContent'
import { TerminosCondicionesContent } from './legal-contents/TerminosCondicionesContent'
import { LegalModal } from './LegalModal'

export type LegalModalType =
  | 'aviso-legal'
  | 'politica-de-privacidad'
  | 'politica-de-cookies'
  | 'terminos-y-condiciones'
  | null

type LegalModalContextType = {
  openModal: (type: LegalModalType) => void
  closeModal: () => void
  currentModal: LegalModalType
}

const LegalModalContext = createContext<LegalModalContextType | undefined>(
  undefined,
)

export function LegalModalProvider({ children }: { children: ReactNode }) {
  const [currentModal, setCurrentModal] = useState<LegalModalType>(null)

  const openModal = (type: LegalModalType) => setCurrentModal(type)
  const closeModal = () => setCurrentModal(null)

  return (
    <LegalModalContext.Provider value={{ openModal, closeModal, currentModal }}>
      {children}
      <LegalModal isOpen={currentModal === 'aviso-legal'} onClose={closeModal}>
        <AvisoLegalContent />
      </LegalModal>
      <LegalModal
        isOpen={currentModal === 'politica-de-privacidad'}
        onClose={closeModal}
      >
        <PoliticaPrivacidadContent />
      </LegalModal>
      <LegalModal
        isOpen={currentModal === 'politica-de-cookies'}
        onClose={closeModal}
      >
        <PoliticaCookiesContent />
      </LegalModal>
      <LegalModal
        isOpen={currentModal === 'terminos-y-condiciones'}
        onClose={closeModal}
      >
        <TerminosCondicionesContent />
      </LegalModal>
    </LegalModalContext.Provider>
  )
}

export function useLegalModal() {
  const context = useContext(LegalModalContext)
  if (context === undefined) {
    throw new Error('useLegalModal must be used within a LegalModalProvider')
  }
  return context
}
